import { render, staticRenderFns } from "./VirtualScroller.vue?vue&type=template&id=2b074817&scoped=true"
import script from "./VirtualScroller.vue?vue&type=script&lang=ts"
export * from "./VirtualScroller.vue?vue&type=script&lang=ts"
import style0 from "./VirtualScroller.vue?vue&type=style&index=0&id=2b074817&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b074817",
  null
  
)

export default component.exports